import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getReminders } from "../../services/reminder.services";
const initialState = {
  reminders: [],
  isLoading: false,
  error: null,
};

export const fetchReminders = createAsyncThunk(
  "reminders/fetchReminders",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getReminders(); // Service correctly returns the data
      return data; // Return the correct data
    } catch (error) {
      console.error("Error in fetchReminders thunk:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch reminders"
      );
    }
  }
);

const reminderSlice = createSlice({
  name: "reminders",
  initialState,
  reducers: {
    setReminders: (state, action) => {
      state.reminders = action.payload;
    },
    clearReminders: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReminders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchReminders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reminders = action.payload; // Populate reminders from API response
      })
      .addCase(fetchReminders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to fetch reminders";
      });
  },
});

export const { setReminders, clearReminders } = reminderSlice.actions;

export default reminderSlice.reducer;
